export default __webpack_public_path__ + "static/media/Rectangle 99.97d9e007.png";